import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/pupa-registrazione-ddt/:agentId',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "TMB Registrazione DDT"] },
    }, {
        path: '/agents/pupa-registrazione-ddt/:agentId/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "TMB Registrazione DDT", "Conversazione"] },
    }]
}]

export default routes;